'use strict'

/* eslint-disable */

// serve with hot reload at localhost:8080
//#npm run dev
// build for production with minification
//#npm run build

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// polyfill all `core-js` features:
import "core-js";
// import 'babel-polyfill'
// import '@babel/polyfill'
// import 'mutationobserver-shim'

import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/plugins/globals'
// import EventBus from '@/plugins/eventbus'
import App from './App'
import router from './router'
import axios from 'axios'
import VueYoutube from 'vue-youtube'

// import Plyr from 'plyr'
import VuePlyr from 'vue-plyr'
// const VuePlyr = require('vue-plyr/dist/vue-plyr.es.js')
// import {VuePlyr} from 'vue-plyr/dist/vue-plyr.ssr.js' // Explicitly use the compiled JS
// import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
// import 'plyr/dist/plyr.css'

import { BIconVolumeDown } from "bootstrap-vue";
import constants from "@/config/constants"
import utils from "@/utils/utils"
import SearchBar from "@/components/SearchBar"
import SearchSidebar from "@/components/SearchSidebar"
import CertButton from "@/components/CertButton"
import QueueButton from "@/components/QueueButton"
import MobileAd from "@/components/MobileAd"
import MobileAdTest from "@/components/MobileAdTest"
import VpFeaturedContent from "@/components/VpFeaturedContent"
import LobbyExam from '@/components/LobbyExam'
import LobbyLive from '@/components/LobbyLive'

// console.log(`defined in webpack.[dev,prod].conf.js?`)
// __VERSION__ defined in package.json
console.log(`__VERSION__  ${__VERSION__}  __BUILD__  ${__BUILD__}` )

// import '@/plugins/bootstrap-vue'

// https://bootstrap-vue.js.org/docs/
// https://developer.okta.com/blog/2018/02/15/build-crud-app-vuejs-node
/// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
/// import 'bootstrap/dist/css/bootstrap.css'
/// import 'bootstrap-vue/dist/bootstrap-vue.css'

/// import { library } from '@fortawesome/fontawesome-svg-core'
/// import { faUserSecret, faKey, faMask, faCat, faAngry, faBell } from '@fortawesome/free-solid-svg-icons'
/// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* eslint-disable no-new */

/// Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
/// Vue.use(IconsPlugin)

Vue.config.productionTip = false

// https://github.com/anteriovieira/vue-youtube
Vue.use(VueYoutube)

// https://github.com/redxtech/vue-plyr
// https://plyr.io/#audio
// https://github.com/sampotts/plyr
// The second argument is optional and sets the default config values for every player.
// see readme.md for custom tweaks to vue-plyr.mjs et al
// window.Plyr = Plyr
// 2/13/26 - made the mistake of trying to upgrade modules and got out of sync with vue-plyr and plyr.
// Spent all day getting it to work again.
// See includes for plyr in index.html
// Only vue-plyr@5.1.0 works.
window.Plyr = window.Plyr || require('plyr')
Vue.use( VuePlyr, {
  plyr: {
    fullscreen: { enabled: true },
    speed: { selected: 1, options: [0.5, 0.75, 1, 1.5, 2] }
  },
  // statechange is youtube only
  emit: ['statechange','ready','canplay','canplaythrough','error','progress','playing','play','pause','ended']
})

// https://v1.vuejs.org/guide/custom-filter.html
// replace newline with <br>
Vue.filter('nl2br', function (value) {
  // here `input` === `this.userInput`
  return (value) ? value.replace(/\r\n/g,'<br>') : value
})

// Converts seconds to HH:MM:SS
Vue.filter('prettyDate', dt => utils.prettyDate(dt))
Vue.filter('prettyDateMin', dt => utils.prettyDateMin(dt))
Vue.filter('prettyDateTime', dt => utils.prettyDateTime(dt))
Vue.filter('prettySeconds', seconds => utils.prettySeconds(seconds))
Vue.filter('prettyNumber', num => utils.prettyNumber(num))
Vue.filter('prettyCEType', typeId => {
    // Tried to put this into utils.  Turbulence.
    // console.log(`prettyCEType  typeId ${typeId} home ${typeId == constants.CE_TYPEID.HOME_STUDY} live ${constants.CE_TYPEID.PARTICIPATORY}`)
    let aout = 'undefined'
    if (typeId == constants.CE_TYPEID.HOMESTUDY) {
        aout = 'Self-Study'
    }
    else if (typeId == constants.CE_TYPEID.PARTICIPATORY) {
        aout = 'Live, Interactive'
    }
    return aout
  })

// TBD add to config
// https://github.com/axios/axios
// https://blog.jscrambler.com/build-a-task-management-app-using-vue-js-and-a-node-js-backend/

const hostMap = {
  defaultRunMode: 'prod',
  sites: {
    local: {
      hosts: ['localhost'],
      api: 'http://localhost:3000',
      desktopUrl: 'http://vivalearning.local'
    },
    test: {
      hosts: ['m.vivalearning.viva9.us','vp-mobile-test.azurewebsites.net'],
      api: 'https://appapi.vivalearning.viva9.us',
      desktopUrl: 'https://vivalearning.viva9.us'
      // api: 'https://vp-mobile-api-test.azurewebsites.net'
    },
    prod: {
      hosts: ['m.vivalearning.com','vp-mobile.azurewebsites.net'],
      api: 'https://appapi.vivalearning.com',
      desktopUrl: 'https://vivalearning.com'
      // api: 'https://vp-mobile-api.azurewebsites.net'
    }
}}

const RUN_MODE_FORCED = ''  // set to local, test, prod to force backend choice
// console.log(Object.keys(hostMap.sites))
let runMode = utils.getRunMode(location.host, hostMap, RUN_MODE_FORCED)

// Define a global accessible via this.$desktopUrl
// Maybe not the best way to do it, but used for example.
Vue.prototype.$desktopUrl = hostMap.sites[runMode].desktopUrl

// let runMode = 'prod'
let baseUrl = utils.getApiBaseUrl(runMode, hostMap)
// console.log(`runMode: ${runMode}  baseUrl: ${baseUrl}`)
axios.defaults.baseURL = baseUrl

// https://github.com/FortAwesome/vue-fontawesome
// add the "solid" icons to the core library
/// library.add(faUserSecret, faKey, faMask, faCat, faAngry, faBell)
/// Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('searchbar', SearchBar)
Vue.component('searchsidebar', SearchSidebar)
Vue.component('certbutton', CertButton)
Vue.component('queuebutton', QueueButton)
Vue.component('mobilead', MobileAd)
Vue.component('mobilead-test', MobileAdTest)
Vue.component('vpfeaturedcontent', VpFeaturedContent)
Vue.component('lobby-exam', LobbyExam)
Vue.component('lobby-webinar', LobbyLive)


// Global Data
// var data = {
//   token: '',  // student token students.hash
//   studentId: 0,
//   studentHash: '',
//   studentName: '',
//   studentEmail: '',
//   desktopUrl: this.runMode.desktop,
//   classId: 0,
//   classHash: '',
//   testval: 'TESTVAL',
//   version: __VERSION__,
//   build: __BUILD__,
//   searchDisplay: null,
//   searchModel: {
//     path: '/search',
//     catId: '',
//     compId: '',
//     query: ''
//   }
// }

var vm = new Vue({
  el: '#app',
  data() {
    return {
      token: '',  // student token students.hash
      studentId: 0,
      studentHash: '',
      studentName: '',
      studentEmail: '',
      classId: 0,
      classHash: '',
      testval: 'TESTVAL',
      version: __VERSION__,
      build: __BUILD__,
      versionApi: '0.0',    // Set by setVersionApi()
      searchDisplay: null,
      searchModel: {
        path: '/search',
        catId: '',
        compId: '',
        query: ''
      }
    }
  },
  router,
  components: { App },
  template: '<App/>',
  methods: {
    getToken() {
      return this.token || localStorage.getItem('id_token') || ''
    },
    setToken(token) {
      this.token = token
      localStorage.setItem('id_token', token)   // used by router(temporarily) and to provide persistence
    },
    getStudentName() {
      return this.studentName || localStorage.getItem('student_name') || ''
    },
    setStudentName(title, firstname, lastname) {
      this.studentName = `${title} ${firstname} ${lastname}`
      localStorage.setItem('student_name', this.studentName)   // used by certs etc...
    },
    getStudentEmail() {
      return this.studentEmail || localStorage.getItem('student_email') || ''
    },
    setStudentEmail(email) {
      this.studentEmail = email
      localStorage.setItem('student_email', this.studentEmail)   // used by certs etc...
    },
    getSearchDisplay() {
      // console.log(`getSearchDisplay: ${this.searchDisplay}`)
      return this.searchDisplay
    },
    setSearchDisplay(val) {
      // console.log(`setSearchDisplay: ${this.searchDisplay}`)
      this.searchDisplay = val
    },
    setSearchModel(model) {
      this.searchModel = {...this.searchModel, ...model}
      // console.log(`setSearchModel: ${this.searchModel.path}`)
      // console.log(this.searchModel)
    },
    hasToken() {
      // console.log(`hasToken: ${this.getToken()} Len: ${this.getToken().length}`)
      return (this.getToken().length !== 0)
    },
    setVersionApi( strVersionApi ) {
      // Since API version is sent from API via JSON, ensure it's a rational value.
      if (typeof strVersionApi === "string" && strVersionApi.length < 10) {
        this.versionApi = strVersionApi
      }
    },
    getVersionApi() { return this.versionApi },
    getVersion() { return this.version },
    getBuild() { return this.build },
    getStudentId () { return this.studentId },
    setStudentId (studentId) { this.studentId = parseInt(studentId) },
    getStudentHash () { return this.studentHash },
    setStudentHash (hash) { this.studentHash = hash },
    getClassId() { return this.classId },
    setClassId(classId) { this.classId = parseInt(classId) },
    getClassHash() { return this.classHash },
    setClassHash(hash) { this.classHash = hash },
    processLogin(data) {}
    // getCompanyName () { return this.companies[this.companyId].name },   // return name of selected company
    // getCompanies () { return Object.values(this.companies);  },
    // setCompanies (companies) {
    //     let obj = {};
    //     companies.forEach((comp)=>{
    //         obj[comp.id] = comp;
    //     });
    //     this.companies = obj;
    // },
    // getReportTypeId () { return this.reportTypeId; },
    // setReportTypeId (reportTypeId) { this.reportTypeId = reportTypeId },
    // getReportParts () { return this.reportParts; },
    // setReportParts (reportParts) { this.reportParts = reportParts; }
  }
})

// Old stuff - does it need to be converted to GA4?
// Handled in router.afterEach?
// ga('set', 'page', '/index.asp')
// ga('send', 'pageview')



// WEBPACK FOOTER //
// ./src/main.js